module.exports = __webpack_public_path__ + "img/logo.aa3e6e49.png";